import { useEscapeKeydown } from "@/hooks/useEscapeKeyDown";
import { useLenis } from "lenis/react";
import React, { useEffect } from "react";

interface ModalProps {
  children?: React.ReactNode;
}

type ModalContextProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

const ModalContext = React.createContext<ModalContextProps | null>(null);

export function useModal() {
  const context = React.useContext(ModalContext);

  if (!context) {
    throw new Error("useModal must be used within <ModalRoot />");
  }

  return context;
}

const ModalRoot = ({ children }: ModalProps) => {
  const [open, setOpen] = React.useState(false);
  const lenis = useLenis();
  useEscapeKeydown((event) => {
    //const isHighestLayer = index === context.layers.size - 1;
    //if (!isHighestLayer) return;
    if (!event.defaultPrevented) {
      event.preventDefault();
      setOpen(false);
    }
  });

  useEffect(() => {
    if (open) {
      lenis?.stop();
    } else {
      lenis?.start();
    }
  }, [open, lenis]);

  return (
    <ModalContext.Provider value={{ open, setOpen }}>
      {children}
    </ModalContext.Provider>
  );
};

export default ModalRoot;
